import React from 'react'
import { useEffect, useState } from 'react';
import { Parallax } from 'react-scroll-parallax';
import './ComponentsCss/Home.css';
import hanjaImg from '../imgs/home/hanja.png';
import img1 from '../imgs/home/img1.png';
import img2 from '../imgs/home/img2.png';
import img3 from '../imgs/home/img3.png';
import img4 from '../imgs/home/img4.png';
import img5 from '../imgs/home/img5.png';
import img6 from '../imgs/home/img6.png';
import img7 from '../imgs/home/img7.png';
import img8 from '../imgs/home/img8.png';
import bannerImg from '../imgs/home/banner.png';

import scaleImg from '../imgs/home/scale.png';
import bookImg from '../imgs/home/book.png';

import "./ComponentsCss/NewsList.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// react slick (sider) 
import Slider from "react-slick";
// axios 
import axios from 'axios';
import NewsItem from './NewsItem';
import { useNavigate } from 'react-router-dom';

const Home = ({ ViewIdxCallBack }) => {
    const navigate = useNavigate(); 

    function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window;
        return {
            width,
            height
        };
    }
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    useEffect(() => {
        console.log(windowDimensions);
    }, [windowDimensions]);
    const [NewsListsArray, SetNewsListsArray] = useState();
    const [CardExpand, SetCardExpand] = useState(false);
    const [CardSelectedIdx, SetCardSelectedIdx] = useState(0);
    function onClickViewIdx() {
        ViewIdxCallBack(1);
    }
    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,

    };
    const multiSettings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
    }
    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }
    useEffect(() => {
        axiosGetNewsLists();
    }, []);
    const axiosGetNewsLists = async () => {
        console.log(" axiosGetNewsLists ");
        var finalIP = "";
      
        finalIP = "https://stepupkorea.kr/api/NewsList/getAllNews";
        try {
            const response = await axios.get(finalIP
            );
            if (response) {
                //console.log(response.data);
                SetNewsListsArray(response.data);
            } else {

            }

        } catch (err) {

            if (!err?.response) {
                console.log('--No Server Response');
            } else if (err.response?.status === 400) {
                console.log('--Missing Username or Password');
            } else if (err.response?.status === 401) {
                console.log('--Unauthorized');
            } else {
                console.log('ERR');
            }

        }
    }


    /* 
    // original front page 

            <div className='home-flex-full-screen-item home-background-accent'>
                <Parallax speed={5}>
                    <div className='home-xxl-text home-text-color-white'>
                        선진변협 활동보고
                    </div>
                </Parallax>
                <Parallax speed={15}>
                    <img src={hanjaImg} className='home-hanja-img' />

                    <div className='home-rounded-button'>
                        8월호 보러가기
                    </div>
                </Parallax>
            </div>
    */
    return (
        <div className='home-flex-col'>

            <div className='home-flex-full-screen-item'>
                <div className="home-slick-container">

                    <Slider {...settings}>
                        {
                            NewsListsArray != null && NewsListsArray.length > 0 ?
                                NewsListsArray.map((newsItem, index) => (
                                    <>
                                        <div className='home-news-flex-box' >
                                            <NewsItem mainImgSrc={newsItem.mainImg} showDetails={false} />
                                            <div className='home-relative-button' onClick={() => { navigate('/case'); }}> 사건 게시판 보기 </div>
                                        </div>
                                    </>
                                ))
                                : null
                        }
                    </Slider>

                </div>
            </div>
            <div className='home-flex-full-width-center home-background-black'>
                <div className='home-flex-auto-h-item '>
                    <div className='home-xl-text home-text-color-accent home-text-margin'> We are</div>
                    <div className='home-xl-text home-text-color-white home-text-margin'>대한민국을 수호하는
                        변호사와 시민모임, 선진변호사협회</div>
                    <div className='home-responsive-box'>

                        <div className='home-nor-text home-text-color-white home-text-margin'> 국가주도 혁명을 넘어,
                            <span style={{ backgroundColor: "var(--mainAccentColor)", fontWeight: "900", marginLeft: "6px" }}> 시민 주도 혁명으로</span></div>
                        <br />
                        <br />
                        <div className='home-nor-text home-text-color-white home-text-margin'>선진변호사협회는 시민과 변호사가 힘을 합쳐

                        </div>
                        <div className='home-nor-text home-text-color-white home-text-margin'>
                            대한민국의 법치를 수호하고 자유민주적 기본질서를

                        </div>
                        <div className='home-nor-text home-text-color-white home-text-margin'>
                            확고히 하기 위해 설립된 단체입니다.
                        </div>
                        <br />
                        <br />
                        <div className='home-nor-text home-text-color-white home-text-margin'> 대한민국의 근본적 자유를 보호하고,
                        </div>
                        <div className='home-nor-text home-text-color-white home-text-margin'>
                            자유민주 국가로서의 가치를 지키기 위해 노력합니다.
                        </div>
                        <div className='home-nor-text home-text-color-white home-text-margin'>
                            선진변호사협회는 2024년 5월 16일,
                        </div>
                        <div className='home-nor-text home-text-color-white home-text-margin'>
                            선진화혁명 선서를 통해 그 시작을 알렸으며,
                        </div>
                        <div className='home-nor-text home-text-color-white home-text-margin'>
                            대한민국 법치수호에 앞장서고 있습니다.</div>
                    </div>
                    <div className='home-responsive-box' >

                        <img src={img2} className='home-imgs-gap' />
                    </div>
                    <div className='home-responsive-box'>
                        <img src={img1} className='home-imgs-gap' />
                    </div>

                    <div className='home-responsive-box'>

                        <br />
                        <div className='home-nor-text home-text-color-white home-text-margin'> 선진화를 향한, 우리의 함성
                            <span style={{ backgroundColor: "var(--mainAccentColor)", fontWeight: "900", marginLeft: "6px" }}> ‘선진화혁명선언문’</span></div>
                        <br />

                        <div className='home-sm-text home-text-color-white home-text-margin'>
                            1. 대한민국은 자유민주 건국과 국가 주도의
                            근대화혁명 연장선에서 민간 주도의 선진화혁명으로
                            도약해야 한다.
                        </div>
                        <br />

                        <div className='home-sm-text home-text-color-white home-text-margin'>
                            2. 대한민국 국민은 각자의 영역에서 민간 주도의
                            선진화혁명을 실천하며 그 과정에서 창의적으로
                            협력해야 한다.
                        </div>
                        <br />

                        <div className='home-sm-text home-text-color-white home-text-margin'>

                            3. 선진화혁명의 실천자들은 장차 자유문명의 선도국가가
                            될 대한민국의 역사적 사명을 굳게 수호해야 한다.

                        </div>
                        <br />
                        <br />
                    </div>


                </div>
            </div>
            <div className='home-flex-full-width-center'>
                <div className='home-flex-auto-h-item'>
                    <div className='home-xl-text home-text-color-accent home-text-margin'> Member</div>
                    <div className='home-xl-text home-text-color-black home-text-margin'>삶에서 대한민국을 수호하는
                        우리들의 드라마</div>

                    {windowDimensions.width > 730 ?
                        <>
                            <div className="home-slick-container-multi">

                                <Slider {...multiSettings}>
                                    <div>
                                        <div style={{ margin: "10px" }}>
                                            <img src={img3} className='home-imgs' />
                                            <div className='home-l-text home-text-color-black home-text-margin'>나는 대한민국 수호의 바톤을 이어받을
                                                드라마입니다</div>
                                            <div className='home-nor-text home-text-color-grey home-text-margin'>자영업자 정회원 김효진님</div>
                                        </div>
                                    </div>

                                    <div>
                                        <div style={{ margin: "10px" }}>
                                            <img src={img4} className='home-imgs' />
                                            <div className='home-l-text home-text-color-black home-text-margin'>나는 청년들의 이야기를 써가는
                                                드라마입니다</div>
                                            <div className='home-nor-text home-text-color-grey home-text-margin'>미국변호사 전문회원 김자훈님</div>
                                        </div>
                                    </div>
                                </Slider>
                            </div>
                        </>
                        :
                        <>
                            <div className="home-slick-container">
                                <Slider {...settings}>
                                    <div>
                                        <img src={img3} className='home-imgs' />
                                        <div className='home-l-text home-text-color-black home-text-margin'>나는 대한민국 수호의 바톤을 이어받을
                                            드라마입니다</div>
                                        <div className='home-nor-text home-text-color-grey home-text-margin'>자영업자 정회원 김효진님</div>
                                    </div>

                                    <div>
                                        <img src={img4} className='home-imgs' />
                                        <div className='home-l-text home-text-color-black home-text-margin'>나는 청년들의 이야기를 써가는
                                            드라마입니다</div>
                                        <div className='home-nor-text home-text-color-grey home-text-margin'>미국변호사 전문회원 김자훈님</div>
                                    </div>
                                </Slider>
                            </div>
                        </>
                    }


                    <br />
                    <br />

                </div>
            </div>
            <div className='home-flex-full-width-center home-background-black'>
                <div className='home-flex-auto-h-item'>
                    <div className='home-xl-text'>
                        <div className='home-xl-text home-text-color-accent home-text-margin'> Goal</div>

                        <div className='home-xl-text home-text-color-white home-text-margin'>
                            <Parallax speed={2}>
                                법과 제도에서 어둠을 몰아내는
                                5,000개의 빛을 모으다
                            </Parallax>
                        </div>
                    </div>
                    <div className='home-responsive-box' >
                        <div className='home-rounded-box-col'>
                            <img src={scaleImg} className='home-small-img' />
                            <div className='home-nor-text home-text-color-grey home-text-margin' style={{ width: "auto" }}>
                                전문회원(변호사)
                            </div>
                            <div className='home-xxl-text home-text-color-white home-text-margin' style={{ width: "auto" }}>
                                100명
                            </div>
                        </div>
                    </div>

                    <div className='home-responsive-box' >

                        <div className='home-rounded-box-col'>
                            <img src={bookImg} className='home-small-img' />
                            <div className='home-nor-text home-text-color-grey home-text-margin' style={{ width: "auto" }}>
                                정회원(시민)
                            </div>
                            <div className='home-xxl-text home-text-color-white home-text-margin' style={{ width: "auto" }}>
                                4,900명
                            </div>
                        </div>
                    </div>

                    <div className='home-xsm-text home-text-color-red home-text-margin' style={{ width: "auto", marginBottom: "15px" }}>

                        *선진변호사협회의 1년 목표입니다.
                        달성을 위해 함께 해주세요
                    </div>
                </div>
            </div>


            <div className='home-flex-auto-h-item'>
                <div className='home-xl-text home-text-color-accent home-text-margin'> What we do</div>
                <div className='home-xl-text home-text-color-black home-text-margin'>전문회원(변호사)</div>
                <div className='home-nor-text home-text-color-grey  '>
                    법률분야의 특수부대
                </div>
                <div className='home-responsive-box' >
                    <img src={img5} className='home-imgs-gap' />
                </div>
                <div className='home-responsive-box' >
                    <img src={img6} className='home-imgs-gap' />
                </div>

                {windowDimensions.width > 730 ?
                    <>
                        <div className='home-flex-row'>

                            <div className='home-wd-25'>
                                <div className='home-l-text home-text-color-black'>법치확립</div>
                                <div className='home-xsm-text home-text-color-black home-text-margin'>  ‘이화영 특검법’ 대표발의자
                                </div>
                                <div className='home-xsm-text home-text-color-black home-text-margin'>
                                    이성윤 의원 직권남용 공동고발</div>
                            </div>

                            <div className='home-wd-25'>
                                <div className='home-l-text home-text-color-black'>공익고발</div>
                                <div className='home-xsm-text home-text-color-black home-text-margin'> 문재인 여적죄 고발
                                </div>
                            </div>
                            <div className='home-wd-25'>
                                <div className='home-l-text home-text-color-black'> 공익소송</div>
                                <div className='home-xsm-text home-text-color-black home-text-margin'>  김일성회고록판매금지 가처분
                                    방역패스해제</div>
                            </div>

                            <div className='home-wd-25'>
                                <div className='home-l-text home-text-color-black'>헌법소원</div>
                                <div className='home-xsm-text home-text-color-black home-text-margin'>
                                    탈원전에 대한 손해배상소송
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='home-flex-row'>
                            <div className='home-wd-25'>
                                <div className='home-l-text home-text-color-black'> 공익적 민사소송</div>
                                <div className='home-xsm-text home-text-color-black home-text-margin'>  5·18특별법 위헌 소원</div>
                            </div>

                            <div className='home-wd-25'>
                                <div className='home-l-text home-text-color-black'>제도개선촉구</div>
                                <div className='home-xsm-text home-text-color-black home-text-margin'>
                                    투표관리관 직접날인 관철
                                </div>
                            </div>
                            <div className='home-wd-25'>
                                <div className='home-l-text home-text-color-black'> 핵심브레인기능</div>
                                <div className='home-xsm-text home-text-color-black home-text-margin'>  우파진영집권과 국정과제플랜 설계</div>
                            </div>

                            <div className='home-wd-25'>
                                <div className='home-l-text home-text-color-black'>리더십 구축</div>
                                <div className='home-xsm-text home-text-color-black home-text-margin'>
                                    건국이념에 바탕한 비전 제시
                                </div>
                            </div>
                        </div>
                        <br />



                    </> :
                    <>
                        <div className='home-flex-row'>

                            <div className='home-wd-50'>
                                <div className='home-l-text home-text-color-black'>법치확립</div>
                                <div className='home-xsm-text home-text-color-black home-text-margin'>  ‘이화영 특검법’ 대표발의자
                                    이성윤 의원 직권남용 공동고발</div>
                            </div>

                            <div className='home-wd-50'>
                                <div className='home-l-text home-text-color-black'>공익고발</div>
                                <div className='home-xsm-text home-text-color-black home-text-margin'> 문재인 여적죄 고발
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='home-flex-row'>
                            <div className='home-wd-50'>
                                <div className='home-l-text home-text-color-black'> 공익소송</div>
                                <div className='home-xsm-text home-text-color-black home-text-margin'>  김일성회고록판매금지 가처분
                                    방역패스해제</div>
                            </div>

                            <div className='home-wd-50'>
                                <div className='home-l-text home-text-color-black'>헌법소원</div>
                                <div className='home-xsm-text home-text-color-black home-text-margin'>
                                    탈원전에 대한 손해배상소송
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='home-flex-row'>
                            <div className='home-wd-50'>
                                <div className='home-l-text home-text-color-black'> 공익적 민사소송</div>
                                <div className='home-xsm-text home-text-color-black home-text-margin'>  5·18특별법 위헌 소원</div>
                            </div>

                            <div className='home-wd-50'>
                                <div className='home-l-text home-text-color-black'>제도개선촉구</div>
                                <div className='home-xsm-text home-text-color-black home-text-margin'>
                                    투표관리관 직접날인 관철
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='home-flex-row'>
                            <div className='home-wd-50'>
                                <div className='home-l-text home-text-color-black'> 핵심브레인기능</div>
                                <div className='home-xsm-text home-text-color-black home-text-margin'>  우파진영집권과 국정과제플랜 설계</div>
                            </div>

                            <div className='home-wd-50'>
                                <div className='home-l-text home-text-color-black'>리더십 구축</div>
                                <div className='home-xsm-text home-text-color-black home-text-margin'>
                                    건국이념에 바탕한 비전 제시
                                </div>
                            </div>
                        </div>
                    </>
                }



                <div className='home-separator'>

                </div>
                <br />
            </div>

            <div className='home-flex-auto-h-item'>
                <div className='home-xl-text home-text-color-black home-text-margin' style={{ textAlign: "right" }}>정회원(시민)</div>
                <div className='home-nor-text home-text-color-grey  ' style={{ textAlign: "right" }}>
                    지역 및 직능별 법치를 선진화 시키는 민간사명자
                </div>
                <div className='home-responsive-box' >
                    <img src={img7} className='home-imgs-gap' />
                </div>
                <div className='home-responsive-box' >
                    <img src={img8} className='home-imgs-gap' />
                </div>

                {windowDimensions.width > 730 ?
                    <>

                        <div className='home-flex-col' style={{ gap: "30px" }}>
                            <div className='home-flex-row home-justify-space'>
                                <div className='home-l-text home-wd-auto'>
                                    공동고발 참여
                                </div>
                                <div className='home-l-text home-wd-auto'>
                                    세미나/강연회/워크숍 참가
                                </div>
                                <div className='home-l-text home-wd-auto'>
                                    지역별·직능별 소모임
                                </div>
                                <div className='home-l-text home-wd-auto'>
                                    문화활동
                                </div>
                            </div>

                            <div className='home-flex-row home-justify-space'>
                                <div className='home-l-text home-wd-auto' style={{ color: "var(--redColor)" }}>
                                    핵심 사명자 그룹의 발굴과 양성
                                </div>
                                <div className='home-l-text home-wd-auto'>
                                    회비납부
                                </div>
                                <div className='home-l-text home-wd-auto'>
                                    독서토론, 봉사활동, 차담회, 등산대회 등
                                </div>

                            </div>

                        </div>
                    </>
                    :
                    <>
                        <div className='home-flex-col' style={{ gap: "30px" }}>
                            <div className='home-flex-row home-justify-space'>
                                <div className='home-l-text home-wd-auto'>
                                    공동고발 참여
                                </div>
                                <div className='home-l-text home-wd-auto'>
                                    세미나/강연회/워크숍 참가
                                </div>
                            </div>
                            <div className='home-flex-row home-justify-space'>
                                <div className='home-l-text home-wd-auto'>
                                    지역별·직능별 소모임
                                </div>
                                <div className='home-l-text home-wd-auto'>
                                    문화활동
                                </div>
                            </div>
                            <div className='home-flex-row home-justify-space'>
                                <div className='home-l-text home-wd-auto' style={{ color: "var(--redColor)" }}>
                                    핵심 사명자 그룹의 발굴과 양성
                                </div>
                                <div className='home-l-text home-wd-auto'>
                                    회비납부
                                </div>
                            </div>
                            <div className='home-flex-row home-justify-space'>
                                <div className='home-l-text home-wd-auto'>
                                    독서토론, 봉사활동, 차담회, 등산대회 등
                                </div>

                            </div>
                        </div>
                    </>
                }


                <br />
                <br />


            </div>
            <div style={{ marginBottom: "100px" }}>

            </div>
            <div className='home-flex-col' style={{ backgroundImage: "url(" + bannerImg + ")", paddingTop: "20px", paddingBottom: "20px" }}>
                <div className='home-l-text home-text-color-white home-text-margin' style={{ textAlign: "center" }}>
                    지금,
                </div>
                <div className='home-l-text home-text-color-white home-text-margin' style={{ textAlign: "center" }}>

                    법치 수호에 동참해주세요
                </div>

                <div className='home-rounded-button home-background-accent' style={{ fontSize: "1rem", margin: "5px 0px 5px 0px", padding: "2px 10px 2px 10px" }}
                    onClick={() => openInNewTab("https://www.ihappynanum.com/Nanum/B/IMMM3QZ6I4")}>
                    회원가입 하러가기
                </div>


            </div>
            <div style={{ marginBottom: "100px" }}>

            </div>
        </div>
    )
}

export default Home

